import React, { FunctionComponent } from 'react';
import getIconForSocialMediaSlug from '../../../../utils/icon';

interface Props {
    name: string;

    className?: string;
    onClick?: () => void;
    to?: string;
}

const SocialMediaIcon: FunctionComponent<Props> = ({ name, className, onClick, to }) => { // TODO: add <Link instead of onClick
    const Icon = getIconForSocialMediaSlug(name);

    return (
        <a href={to} className={className} target={'_blank'} rel="noreferrer">
            <Icon className={className} onClick={onClick} />
        </a>
    );
};

export default SocialMediaIcon;
